var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalDebit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "#00873D",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 25.5L11.6875 14.9375C11.6875 14.722 11.7731 14.5153 11.9255 14.363C12.0779 14.2106 12.2845 14.125 12.5 14.125C12.7155 14.125 12.9222 14.2106 13.0746 14.363C13.2269 14.5153 13.3125 14.722 13.3125 14.9375L13.3125 23.5388L24.9252 11.9252C25.0777 11.7727 25.2844 11.687 25.5 11.687C25.7156 11.687 25.9224 11.7727 26.0749 11.9252C26.2273 12.0776 26.313 12.2844 26.313 12.5C26.313 12.7156 26.2273 12.9224 26.0749 13.0748L14.4612 24.6875L23.0625 24.6875C23.278 24.6875 23.4847 24.7731 23.6371 24.9255C23.7894 25.0778 23.875 25.2845 23.875 25.5C23.875 25.7155 23.7894 25.9222 23.6371 26.0745C23.4847 26.2269 23.278 26.3125 23.0625 26.3125L12.5 26.3125C12.2845 26.3125 12.0779 26.2269 11.9255 26.0745C11.7731 25.9221 11.6875 25.7155 11.6875 25.5Z",
    fill: "#00873D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDebit);
export default __webpack_public_path__ + "static/media/total-debit.5eaa69bd7316e6afe8afbd4e2a660a56.svg";
export { ForwardRef as ReactComponent };